import { Box, Grid, Grid2, IconButton, InputAdornment } from "@mui/material"
import { Autocomplete, Button, CurrencyInput, Input, Loader, Modal, NumericInput } from "../../../components"
import { useFormik } from "formik"
import { Add } from "@mui/icons-material"
import { useMilespayAPI, useToggle } from "../../../hooks"
import {CreateCustomerSchema} from '@milespay.co/validations'
import { enqueueSnackbar } from "notistack"

interface AddCustomerModalProps {
    onClose: () => void
    onSuccess: (customerId: string) => void
}

export const AddCustomerModal = ({ onClose, onSuccess }: AddCustomerModalProps) => {
    const [createCustomer, createCustomerControls] = useMilespayAPI({
        url: '/company-customer',
        method: 'POST',
    }, { manual: true })

    const formik = useFormik({
        initialValues: {
            name: '',
            email: ''
        },
        validationSchema: CreateCustomerSchema,
        onSubmit: async (values) => {
            const response = await createCustomerControls({
                data: values
            })

            if (response.status >= 200) {
                enqueueSnackbar('Cliente criado com sucesso!', {variant: 'success'})
                onSuccess(response.data.id)
            }
        }
    })

    return (
        <>
            <Modal
                title="Adicionar Cliente"
                open
                onClose={createCustomer.loading ? undefined : onClose}
                bodyCustomCss={{
                    width: 400
                }}
                onConfirm={createCustomer.loading ? undefined : formik.submitForm}
                confirmLabel="Adicionar"
            >
                <Box>
                    {createCustomer.loading ? (
                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Loader />
                        </Box>
                    ) :(<Grid2 container spacing={1}>
                        <Grid2 size={{xs: 12}}>
                            <Input 
                                label="Nome"
                                name="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={!!formik.touched.name && !!formik.errors.name}
                                helperText={formik.touched.name && formik.errors.name}
                                value={formik.values.name}
                            />
                        </Grid2>
                        <Grid2 size={{xs: 12}}>
                            <Input 
                                label="E-mail"
                                name="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={!!formik.touched.email && !!formik.errors.email}
                                helperText={formik.touched.email && formik.errors.email}
                                value={formik.values.email}
                            />
                        </Grid2>
                    </Grid2>)}
                </Box>
            </Modal>
        </>
    )
}